import React, { useEffect } from 'react';
import { PaymentForm, useCreditCardFormState } from '@fff-web/fff-payments';
import { track } from '@fff-web/fff-analytics';
import '@fff-web/fff-payments/dist/recurly.css';
import { datadogLogs } from '@datadog/browser-logs';
import IDDLogger from '@fff-web/fff-payments/dist/interfaces/IDDLogger';
import PaymentIcons from './PaymentIcons';
import styles from './scss/PaymentFormContainer.module.scss';
import { useSharedContext } from '../../ContextProviders/SharedContext';
import { useAppContext } from '../../../../utils/ContextProviders/AppContext';
import { FORM_INPUT_EVENT, FORM_TYPE_INTRO_PRODUCT, PAYMENT_INFO_INPUT_FIELD } from '../../../../utils/segment/constants';

type Props = {
  flags: any,
};

const PaymentFormContainer = (props: Props) => {
  const { flags } = props;
  const { setFlags } = useAppContext();
  const payFieldsState = useCreditCardFormState(false);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { first_name, last_name } = payFieldsState.fields;
  const {
    prospect, setProspect, setIsRecurlyFormValid, checkoutTotal,
  } = useSharedContext();
  const trackInputs = () => {
    const properties = {
      form_type: FORM_TYPE_INTRO_PRODUCT,
      input_field: PAYMENT_INFO_INPUT_FIELD,
    };
    track({ trackName: FORM_INPUT_EVENT, properties });
  };

  useEffect(() => {
    setFlags(flags);
  }, [flags]);

  useEffect(() => {
    setIsRecurlyFormValid(!payFieldsState.hasErrors);
  }, [payFieldsState.hasErrors]);

  useEffect(() => {
    setProspect({
      ...prospect,
      firstName: first_name.value as string,
      lastName: last_name.value as string,
    });
  }, [first_name.value, last_name.value]);

  return (
    <section className={styles.pfContainer}>
      <div className={styles.pfContainerHeaderWrapper}>
        <h3 className={styles.pfContainerTitle}>Payment Info</h3>
        <div className={styles.pfContainerPayments}>
          <PaymentIcons />
        </div>
      </div>
      <PaymentForm
        payFieldsState={payFieldsState}
        billingCountry={prospect.address.shipCountry}
        flags={flags}
        fieldTracking={trackInputs}
        checkoutTotal={checkoutTotal}
        datadogLogs={datadogLogs}
      />
    </section>
  );
};

export default PaymentFormContainer;
